import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import AddBlogLayer from "../../components/AddBlogLayer";
import MasterLayout from "../../masterLayout/MasterLayout";
import AddBlog from "../../components/AddBlog/AddBlog";
import EditBlog from "../../components/EditBlog/EditBlog";
const EditBlogPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Edit Blog' />

                <EditBlog />
            </MasterLayout>
        </>
    );
};

export default EditBlogPage;
